export function isUrl(check: string): boolean {
  try {
    const url = new URL(check);
    return url.hostname.length > 0;
  } catch (_) {
    return false;
  }
}
